module.exports = __webpack_public_path__ + "static/media/imgPoC2.700a011e.svg";